import React from 'react';


const VettingGreenTick = () => {

  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.44944 9.93057C4.29323 9.77436 4.03997 9.77436 3.88376 9.93057C3.72755 10.0868 3.72755 10.34 3.88376 10.4963L7.52022 14.1327C7.67643 14.2889 7.92969 14.2889 8.0859 14.1327L16.2682 5.95042C16.4244 5.79421 16.4244 5.54095 16.2682 5.38474C16.112 5.22853 15.8587 5.22853 15.7025 5.38474L7.80306 13.2842L4.44944 9.93057Z" fill="#333333" />
      <mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="3" y="5" width="14" height="10">
        <path d="M4.44944 9.93057C4.29323 9.77436 4.03997 9.77436 3.88376 9.93057C3.72755 10.0868 3.72755 10.34 3.88376 10.4963L7.52022 14.1327C7.67643 14.2889 7.92969 14.2889 8.0859 14.1327L16.2682 5.95042C16.4244 5.79421 16.4244 5.54095 16.2682 5.38474C16.112 5.22853 15.8587 5.22853 15.7025 5.38474L7.80306 13.2842L4.44944 9.93057Z" fill="white" />
      </mask>
      <g mask="url(#mask1)">
        <rect y="0.100098" width="20" height="20" fill="#428600" />
      </g>
    </svg>
  );
}

export default VettingGreenTick;